
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HinaCheckbox from "./hina-checkbox.vue";

@Component({
  components: { HinaCheckbox }
})
export default class HinaCheckboxGroup extends Vue {
  @Prop() value!: any;
  @Prop({ default: () => [] }) options!: {
    name: string;
    value: any;
    disabled?: boolean;
  }[];

  v = this.value;

  @Watch("value", { immediate: true })
  handleValueChange() {
    this.v = this.value;
  }

  handleChange() {
    this.$emit("update:value", this.v);
    this.$emit("change", this.v);
  }
}
